import { MouseEvent } from '@agm/core';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-google-map',
  templateUrl: './google-map.component.html',
  styles: ['']
})
export class GoogleMapComponent implements OnInit {
  @Input() lat: number;
  @Input() lng: number;
  @Input() lable!: string;
  @Input() canPick: boolean = false;

  @Output() Location = new EventEmitter<LocationInterface>();
  Marker: marker

  ngOnInit(): void {
    // if (this.lat && this.lng) {
    //   this.marker = {
    //     position: {
    //       lat: Number(this.lat),
    //       lng: Number(this.lng)
    //     },
    //     label: this.lable ? { text: this.lable, className: 'map_lable' } : null
    //   }

    //   // this.MapInfo = { content: this.lable, position: this.marker.position };

    //   this.MapCenter = {
    //     lat: Number(this.lat),
    //     lng: Number(this.lng)
    //   }
    //   this.MapZoom = null;
    // } else {
    //   this.MapCenter = {
    //     lat: 24.774265,
    //     lng: 46.738586
    //   }

    //   this.MapZoom = 7;
    // }


    // this.mapOptions = {
    //   mapId: 'customMap15',
    //   scrollwheel: true,
    //   disableDoubleClickZoom: false,
    //   mapTypeId: 'roadmap',
    //   zoomControl: true,
    //   fullscreenControl: true,
    //   mapTypeControl: false,
    //   streetViewControl: false
    // }

  };

  ngOnChanges(changes: any): void {

    if (this.lat && this.lng) {
      this.Marker = {
        lat: Number(this.lat),
        lng: Number(this.lng),
        draggable: false
      };
    }
  }

  mapClicked($event: MouseEvent) {
    if (this.canPick) {
      this.Marker = {
        lat: $event.coords.lat,
        lng: $event.coords.lng,
        draggable: false
      };

      this.Location.emit({
        map_lat: Number($event.coords.lat),
        map_lang: Number($event.coords.lng)
      })
    }
  }

  onMapReady(map?: any) {
    if (map)
      map.setOptions({
        streetViewControl: false,
        fullscreenControl: false
      });
  }

}

export interface LocationInterface {
  map_lang: number,
  map_lat: number
}

// just an interface for type safety.
interface marker {
  lat: number;
  lng: number;
  label?: string;
  draggable: boolean;
}
